import styled from "styled-components";

export const Title = styled.h1`
  box-sizing: border-box;
  margin: auto;
  background-color: aliceblue;
  font-size: 1.5rem;
  text-align: center;
  color: #2c3a47;
  width: 100%;
  border-radius: 50px 20px;
  padding: 25px;
`;
